import csi from "csi/main";
import reflection from "csi/reflection";
import Cache from "csi/state/Cache";
import { AccessRule, C8Node } from "csi/typings";
import { nodeHasAttribute } from "csi/utility/nodeUtility";
import xml from "csi/xml";
import { evaluate } from "csi/middleware/rollup/rollupService";

const {
	OP_EQUALS,
	OP_EXISTS,
	OP_GREATER_EQUAL,
	OP_GREATER_THAN,
	OP_LESS_EQUAL,
	OP_LESS_THAN,
	OP_NOT_EQUALS,
	OP_NOT_EXISTS,
	OP_NOT_NULL,
	OP_NULL,
	OP_OR_EQUALS,
} = xml;

// convert 'true' and 'false' values into strings for comparison
const _getValue = (val: any): any => ((val === true) || (val === false)) ? String(val) : val;

/**
 * Return true if given rule passes
 */
export function rulePasses(
	rule: AccessRule,
	node: C8Node,
	cache: Cache,
	index1?: number | string,
	index2?: number | string,
	setEvaluatedAttributes?: Set<string>,
): boolean {
	const {
		exp,
		id1,
		id2,
		op,
		path,
		setting,
		value,
	} = rule;

	const nodePath = cache.getPathNode(node, path);
	if (!nodePath) {
		return false;
	}

	// if string then evaluate as rollup expression
	if (exp) {
		const result = evaluate(exp, nodePath, cache);
		return result == true;
	}

	if (id1) {
		if (op == OP_EXISTS) {
			return nodeHasAttribute(nodePath, id1);
		} else if (op == OP_NOT_EXISTS) {
			return !nodeHasAttribute(nodePath, id1);
		}
	}

	const attr = (id: string, index: number | string): any => {
		// TODO: for now, not worried about evaluating expressions of attributes used in rules (see csi/def/Rule#passes);
		// once we do, pass in set of evaluated attributes to track those that have already been evaluated (replace functionality in csi/rollup/Processor)
		const result = _getValue(nodePath[id]);
		return index === undefined ? result : result[index];
	};

	const v1 = id1 ? attr(id1, index1) : _getValue(reflection.getNodeSetting(nodePath, setting));
	const v2 = id2 ? attr(id2, index2) : _getValue(value);

	switch (op) {
		case OP_EQUALS: return v1 == v2;
		case OP_NOT_EQUALS: return v1 != v2;
		case OP_LESS_THAN: return v1 < v2;
		case OP_LESS_EQUAL: return v1 <= v2;
		case OP_GREATER_THAN: return v1 > v2;
		case OP_GREATER_EQUAL: return v1 >= v2;
		case OP_NOT_NULL: return !(v1 == null || v1 == csi.EMPTY_URL);
		case OP_NULL: return (v1 == null || v1 == csi.EMPTY_URL);
		case OP_OR_EQUALS: return v2.split(";").some((v: string) => { v1 == v; });
	}

	console.warn("Unknown Rule operation: ", rule);
	return false;
}